import React, { useState, useEffect } from "react";
import { NavLink, useParams, Link } from "react-router-dom";
import UserHeader from "./UserHeader";
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import {
  getAnalysisRegionList,
  getAnalysisCountriesList,
  getAnalysisProfessionList,
} from "../../Utils/adminFunctions";
import {
  getUserAnalysisChartData,
  getUserAnalysisChartGenerate,
} from "../../Utils/userFunctions";
import {
  get_Date,
  getSurveyStatusName,
  getDataArr,
} from "../../Utils/commonFunctions";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const UserCreateAnalysis = () => {
  const { surveyID } = useParams(); ///survey ID
  const [listRegions, setListRegions] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [listCountries, setListCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [listProfession, setListProfession] = useState([]);
  const [selectedProfession, setSelectedProfession] = useState([]);
  const [currentItems, setCurrentItems] = useState(1);
  const [totalRecords, setTotalRecords] = useState();
  const [tempQuestionID, setTempQuestionID] = useState("");
  const [tempQuestionNo, setTempQuestionNo] = useState("");
  const [tempQuestionText, setTempQuestionText] = useState("");
  const [tempChartNo, setTempChartNo] = useState("");
  const [tempSaveButtonShow, setTempSaveButtonShow] = useState("hide");
  const [chartData, setChartData] = useState([]);
  const [chartBase64Content, setChartBase64Content] = useState([]);
  const [surveyData, setSurveyData] = useState("");
  const [surveyType, setSurveyType] = useState("");
  const [surveyLabel, setSurveyLabel] = useState("");
  const [surveyStatus, setSurveyStatus] = useState("");
  const [hideBar, setHideBar] = useState(0);
  const [title, setTitle] = useState("");
  const labels = [""];
  useEffect(() => {
    getSurveyData(currentItems);
    getSurveyRegion();
    getData();
  }, []);
  const getSurveyData = async (currentItems) => {
    const response = await getUserAnalysisChartData(surveyID, currentItems);
    if (response.status == "success") {
      setSurveyType(response.data[0].question_type);
      setSurveyData(response.data[0]);
      setSurveyStatus(response.data[0].status);
      setTotalRecords(response.data[0].total_records);
      setTempQuestionID(response.data[0].question_id);
      setTempQuestionText(response.data[0].label);
      setSurveyLabel(response.data[0].survey_type_label);
      setTempQuestionNo(response.data[0].question_no);
      setTempChartNo(response.data[0].no_of_charts);
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const getSurveyRegion = async () => {
    try {
      const response = await getAnalysisRegionList(surveyID);
      setListRegions(response.optionItems);
    } catch (error) {
      setListRegions(null);
    }
  };
  const getCountryByRegion = async (regions) => {
    try {
      let bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(regions);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      const response = await getAnalysisCountriesList(bodyFormData);
      setListCountries(response.optionItems);
    } catch (error) {
      setListCountries(null);
    }
  };

  const getProfessionByRegion = async (regions) => {
    try {
      let bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(regions);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      const response = await getAnalysisProfessionList(bodyFormData);
      setListProfession(response.optionItems);
    } catch (error) {
      setListProfession(null);
    }
  };

  const getProfessionByRegionAndCountry = async (country) => {
    try {
      let bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(selectedRegions);
      let countrySelectedArr = getDataArr(country);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      bodyFormData.append("country", countrySelectedArr);
      const response = await getAnalysisProfessionList(bodyFormData);
      setListProfession(response.optionItems);
    } catch (error) {
      setListProfession(null);
    }
  };

  const handleFilter = async () => {
    setHideBar(0);
    if (
      selectedRegions.length == 0 &&
      selectedCountries.length == 0 &&
      selectedProfession.length == 0
    ) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }
    let bodyFormData = new FormData();
    let selectedRegionsArr = getDataArr(selectedRegions);
    let selectedCountriesArr = getDataArr(selectedCountries);
    let selectedProfessionArr = getDataArr(selectedProfession);
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("question_id", tempQuestionID);
    bodyFormData.append("action", "filter");
    bodyFormData.append("region_filters", selectedRegionsArr);
    bodyFormData.append("country_filters", selectedCountriesArr);
    bodyFormData.append("profession_filters", selectedProfessionArr);
    const response = await getUserAnalysisChartGenerate(bodyFormData);
    if (response.status === "success") {
      let tmpArr = Object.values(response.data.datasets);
      if (tmpArr.length > 0) {
        setTitle(response.data.title);
        setChartData(tmpArr);
        setTimeout(function () {
          let url_base64jp = document
            .getElementById("barChart")
            .toDataURL("image/png");
          setChartBase64Content(url_base64jp);
        }, 1000);
        setTempSaveButtonShow("show");
      } else {
        setHideBar(1);
        setTitle([]);
        setChartData([]);
        setChartBase64Content([]);
      }
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };

  const graphChartSave = async () => {
    setHideBar(1);
    let selectedRegionsArr = getDataArr(selectedRegions);
    let selectedCountriesArr = getDataArr(selectedCountries);
    let selectedProfessionArr = getDataArr(selectedProfession);
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("question_id", tempQuestionID);
    bodyFormData.append("action", "save_graph");
    bodyFormData.append("region_filters", selectedRegionsArr);
    bodyFormData.append("country_filters", selectedCountriesArr);
    bodyFormData.append("profession_filters", selectedProfessionArr);
    bodyFormData.append("graph_image", chartBase64Content);
    const response = await getUserAnalysisChartGenerate(bodyFormData);
    if (response.status == "success") {
      getSurveyData(currentItems);
      setChartData([]);
      setTempSaveButtonShow("hide");
      setListCountries([]);
      setListProfession([]);
      setTitle("");
      toast.success(response.message, { autoClose: 1500 });
    }
    if (response.status == "failure") {
      toast.warning(response.message, { autoClose: 1500 });
    }
    if (response.status == "error") {
      toast.error(response.message, { autoClose: 1500 });
    }
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title ? title : "",
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };

  const handleClickPagination = (item) => {
    setHideBar(1);
    setCurrentItems(item);
    setChartData([]);
    setTempSaveButtonShow("hide");
    setSelectedRegions([]);
    setSelectedCountries([]);
    setSelectedProfession([]);
    getSurveyData(item);
    setListCountries([]);
    setListProfession([]);
  };

  function PaginatedItems() {
    const items = Array.from({ length: totalRecords }, (x, i) => i);
    let tempList = items.map((item, i) => (
      <li
        className={item == currentItems - 1 ? "page-item active" : "page-item "}
        key={i}
      >
        <NavLink
          to="#"
          className="page-link"
          onClick={() => {
            handleClickPagination(item);
          }}
        >
          {++item}
        </NavLink>
      </li>
    ));

    return (
      <nav aria-label="Page navigation example">
        <ul className="pagination">{tempList}</ul>
      </nav>
    );
  }

  /* pagination code */
  function getData() {
    let tmpReturnData = {
      labels,
      datasets: chartData,
    };
    return tmpReturnData;
  }

  return (
    <div>
      <UserHeader />
      <ToastContainer></ToastContainer>
      <div className="container">
        <div className="row mt-4">
          <div className="row">
            <div className="col-md-4">
              <div className="card vd-card">
                <div className="card-body">
                  <div className="pmcf-content-info">
                    <span className="custom_survey_name">
                      {surveyData.survey_name}
                    </span>
                    <hr
                      style={{
                        border: "1px solid #006CB5",
                        borderRadius: 10,
                      }}
                    />

                    <div
                      className="pmcf-survey-list"
                      style={{ marginTop: "5%" }}
                    >
                      <div className="pmcf-survey-item">
                        <div className="pmcf-survey-text">Status</div>
                        <div className="pmcf-survey-value">
                          {getSurveyStatusName(surveyStatus)}
                        </div>
                      </div>
                      <div className="pmcf-survey-item">
                        <div className="pmcf-survey-text">Launch Date</div>
                        <div className="pmcf-survey-value">
                          {surveyData.launch_date
                            ? get_Date(surveyData.launch_date)
                            : "Survey is yet to be launched"}
                        </div>
                      </div>
                      <div className="pmcf-survey-item">
                        <div className="pmcf-survey-text">Completion Date</div>
                        <div className="pmcf-survey-value">
                          {get_Date(surveyData.completion_date)}
                        </div>
                      </div>
                    </div>
                    <div className="pmcf-survey-question-point">
                      <h2 style={{ color: "#006CB5" }}>
                        {" "}
                        {surveyData.no_of_question}
                      </h2>
                      <p style={{ color: "black" }}>QUESTIONS</p>
                    </div>
                    <div className="pmcf-survey-list">
                      <div className="pmcf-survey-item">
                        <div className="pmcf-survey-text">
                          Number of Participants
                        </div>
                        <div className="pmcf-survey-value">
                          {" "}
                          {surveyData.no_of_paticipants}
                        </div>
                      </div>
                      <div className="pmcf-survey-item">
                        <div className="pmcf-survey-text">Responses</div>
                        <div className="pmcf-survey-value">
                          {surveyData.no_of_responses} /{" "}
                          {surveyData.no_of_paticipants}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-8">
              <div className="card vd-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 text-right">
                      <Link
                        to={"/UserSurveyDetails/" + surveyID}
                        className="btn btn-sm btn-primary custom-btn-primary"
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </Link>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="custom-label-font-weight">
                          Region
                        </label>
                        <MultiSelect
                          options={listRegions}
                          value={selectedRegions}
                          onChange={(e) => {
                            getCountryByRegion(e);
                            getProfessionByRegion(e);
                            setSelectedRegions(e);
                          }}
                          labelledBy="Select"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="custom-label-font-weight">
                          Country
                        </label>
                        <MultiSelect
                          options={listCountries}
                          value={selectedCountries}
                          onChange={(e) => {
                            getProfessionByRegionAndCountry(e);
                            setSelectedCountries(e);
                          }}
                          labelledBy="Select"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="custom-label-font-weight">
                          Profession
                        </label>

                        <MultiSelect
                          options={listProfession}
                          value={selectedProfession}
                          onChange={setSelectedProfession}
                          labelledBy="Select"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <span className="custom-label-font-weight">.</span>
                        <br></br>
                        <button
                          className="btn btn-block custom-btn-primary btn-xs"
                          onClick={handleFilter}
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card dev_card">
                <div className="card-header bg-white">
                  <div className="sar-question mt-2 p-1">
                    <div className="sar-question-number">{tempQuestionNo}</div>{" "}
                    <div className="sar-question-text">
                      <p>
                        {tempQuestionText}
                        {surveyType === "survey" ? " > " + surveyLabel : ""}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card-body create-graph-box-height">
                  <div className="row">
                    <div className="col-md-10">
                      {hideBar == 0 && (
                        <Bar
                          id="barChart"
                          options={options}
                          data={getData()}
                          height={60}
                        />
                      )}
                    </div>
                    <div className="col-md-2 text-right">
                      <span>No of Charts: {tempChartNo}</span>
                    </div>
                  </div>
                </div>

                <div className="card-footer bg-white">
                  <span className="pull-right">{<PaginatedItems />}</span>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <button
                    className={
                      "btn btn-sm custom-btn-primary" +
                      (tempSaveButtonShow === "hide" ? " hidden-custom" : "")
                    }
                    onClick={graphChartSave}
                  >
                    Save
                  </button>{" "}
                  <Link
                    className="btn btn-sm custom-btn-primary"
                    to={
                      "/manufacturer/analysis/preview/" +
                      surveyID +
                      "/" +
                      tempQuestionID +
                      "/" +
                      currentItems
                    }
                  >
                    Preview
                  </Link>
                </div>
                <div className="col-md-6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserCreateAnalysis;
